import { Component, input, InputSignal, ChangeDetectionStrategy } from '@angular/core';
import { MatList, MatListItem, MatListItemLine, MatListItemTitle } from '@angular/material/list';
import { LuxonDatePipe } from '@libs/shared/ui';
import { DateTime } from 'luxon';

@Component({
  selector: 'ui-order-delivery',
  templateUrl: './order-delivery.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    LuxonDatePipe,
    MatList,
    MatListItem,
    MatListItemLine,
    MatListItemTitle,
  ],
})
export class OrderDeliveryComponent {
  public deliveryDate: InputSignal<DateTime | undefined> = input();
}
